import { t } from '../i18n';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/skip-nav/).
 */
export const SkipNav = _ref => {
  let {
    children,
    href,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("a", {
    className: "ds-c-skip-nav",
    href: href,
    onClick: onClick,
    children: children ?? t('skipNav.default')
  });
};
export default SkipNav;